<template>
  <div className="editable-sample-edge-label"></div>
</template>

<script>
export default {
  setup() {},
};
</script>
